import { render, staticRenderFns } from "./AppShare.vue?vue&type=template&id=49a00bac&scoped=true"
import script from "./AppShare.vue?vue&type=script&lang=js"
export * from "./AppShare.vue?vue&type=script&lang=js"
import style0 from "./AppShare.vue?vue&type=style&index=0&id=49a00bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a00bac",
  null
  
)

export default component.exports